import styled from '@emotion/styled'

type SectionBlockProps = {
	title: string
	isButton?: boolean
	btnTxt?: string
	onClick?: () => void
	children: React.ReactNode
}

const SectionBlock = ({ title, isButton, btnTxt, onClick, children }: SectionBlockProps) => {
	return (
		<Block>
			<div>
				<SectionHeader>
					<Title>{title}</Title>
					{isButton && (
						<Button type="button" onClick={onClick}>
							{btnTxt}
						</Button>
					)}
				</SectionHeader>
				{children}
			</div>
		</Block>
	)
}

const Block = styled.section`
	display: flex;
	width: 100%;
	padding: 3rem 0 0.6rem;

	& > div {
		width: 100%;
	}
`

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
`

const Title = styled.h3`
	font-size: 1.7rem;
	font-weight: 600;
	line-height: 2.4rem;
	color: #130f26;
`

const Button = styled.button`
	border: none;
	border-radius: 0.4rem;
	background-color: #ffcf19;
	font-size: 1.2rem;
	font-weight: 600;
	padding: 0.7rem;
	margin-left: 1rem;
`

export default SectionBlock
